import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-activate-account-popup',
  templateUrl: './activate-account-popup.component.html',
  styleUrls: ['./activate-account-popup.component.scss'],
  standalone: true,
  imports: [
    TranslateModule,
  ]
})
export class ActivateAccountPopupComponent implements OnInit {

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
  }

}
